/**
 * CRO — mobile ATC opens cart drawer (GB / US / CH / AU)
 * Draft theme only. No shipping bar / free-shipping progress.
 * Pipeline fires theme:cart:popdown on the popdown node (bubbles);
 * we catch it (and a MutationObserver fallback) and open the cart drawer.
 */
(function () {
  var MARKETS = { GB: true, US: true, CH: true, AU: true };
  var MQ = '(max-width: 989px)'; // Pipeline mobile layout + small desktop windows

  function country() {
    try {
      return String((window.Shopify && Shopify.country) || '').toUpperCase();
    } catch (e) {
      return '';
    }
  }

  function isPreview() {
    try {
      return /(?:^|[?&])preview_theme_id=/.test(location.search);
    } catch (e) {
      return false;
    }
  }

  function isMobile() {
    return window.matchMedia && window.matchMedia(MQ).matches;
  }

  function enabled() {
    if (!isMobile()) return false;
    if (MARKETS[country()]) return true;
    // Allow verification under theme preview from any geo
    if (isPreview()) return true;
    return false;
  }

  function ensureStyle() {
    if (document.getElementById('te-mcatc-style')) return;
    var st = document.createElement('style');
    st.id = 'te-mcatc-style';
    st.textContent =
      '@media (max-width: 989px){' +
      'html.te-mcatc .product-add-popdown.is-visible{display:none!important;visibility:hidden!important;pointer-events:none!important}' +
      'html.te-mcatc .drawer.cart__drawer .drawer__checkout__additional,' +
      'html.te-mcatc .drawer.cart__drawer .additional-checkout-buttons{display:none!important}' +
      '}';
    document.head.appendChild(st);
  }

  function hidePopdown() {
    var pop = document.querySelector('[data-product-add-popdown-wrapper]');
    if (pop) pop.classList.remove('is-visible');
  }

  function openCartDrawer() {
    if (!enabled()) return;
    ensureStyle();
    document.documentElement.classList.add('te-mcatc');
    hidePopdown();

    var drawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (!drawer) return;

    try {
      document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
    } catch (e) {}

    var ajaxCart = document.querySelector('[data-ajax-disable="false"]');
    if (ajaxCart) {
      try {
        ajaxCart.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      } catch (e2) {}
    }

    // Same path Pipeline uses from the popdown "View cart" button
    try {
      drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
    } catch (e3) {}

    // Backup: toggle control in the header
    if (!drawer.classList.contains('drawer--visible')) {
      var toggle = document.querySelector('[data-drawer-toggle="drawer-cart"]');
      if (toggle) {
        try {
          toggle.click();
        } catch (e4) {}
      }
    }

    setTimeout(function () {
      hidePopdown();
      var btn = drawer.querySelector('.checkout__button, button[name="checkout"]');
      if (!btn) return;
      try {
        btn.focus({ preventScroll: true });
      } catch (e5) {
        try {
          btn.focus();
        } catch (e6) {}
      }
    }, 400);
  }

  function onPopdown(e) {
    if (!enabled()) return;
    try {
      e.stopImmediatePropagation();
      e.stopPropagation();
      e.preventDefault();
    } catch (err) {}
    openCartDrawer();
  }

  // Capture on document — event is dispatched on the popdown node with bubbles:true
  document.addEventListener('theme:cart:popdown', onPopdown, true);

  // Fallback if another listener wins the race: when toast becomes visible, swap to drawer
  function watchPopdown() {
    var pop = document.querySelector('[data-product-add-popdown-wrapper]');
    if (!pop || pop.dataset.teMcatcWatch) return;
    pop.dataset.teMcatcWatch = '1';
    var obs = new MutationObserver(function () {
      if (!enabled()) return;
      if (pop.classList.contains('is-visible')) {
        openCartDrawer();
      }
    });
    obs.observe(pop, { attributes: true, attributeFilter: ['class'] });
  }

  function boot() {
    ensureStyle();
    watchPopdown();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
